import NoContentLabel from 'conversations-message-history/atoms/NoContentLabel';
import I18n from 'I18n';
import InlineImageAttachments from '../attachments/components/InlineImageAttachments';
import { getNonImageAttachments, hasImageAttachments
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
import ContentText from '../atoms/ContentText';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getPlainText, getRichText, getSenderType
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { VISITOR as VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import AttachmentsFooter from '../attachments/components/AttachmentsFooter';
import PrimaryMessageContent, { PrimaryMessageContentWrapper } from '../primary-message/components/PrimaryMessageContent';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import ThemeContext from '../theming/contexts/ThemeContext';
import { darken } from '../utils/colors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'auto... Remove this comment to see the full error message
import autolinker from 'autolinker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HyperlinkStyleWrapper = styled.div.withConfig({
  displayName: "CommonMessageContent__HyperlinkStyleWrapper",
  componentId: "yuiot9-0"
})(["overflow:hidden;", " a{color:", ";&:hover{color:", ";}&:active{color:", ";}}"], PrimaryMessageContentWrapper, ({
  hyperlinkColor
}) => hyperlinkColor, ({
  hyperlinkColor
}) => hyperlinkColor && darken(hyperlinkColor), ({
  hyperlinkColor
}) => hyperlinkColor && darken(hyperlinkColor, 0.2));
class CommonMessageContent extends PureComponent {
  isSentFromVisitor() {
    return getSenderType(this.props.message) === VISITOR_SENDER;
  }
  isClickableLink(contentText) {
    const linkRegex = new RegExp('([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?');
    return linkRegex.test(contentText);
  }
  handleOnClickEvent(event) {
    event.persist();
    if (event.target instanceof HTMLElement && event.target.tagName === 'A') {
      this.props.toggleOpen({
        isOpened: false,
        isUser: true
      });
    }
  }
  renderContentText() {
    const {
      message,
      mobile,
      isLastMessage,
      senderName
    } = this.props;
    const contentText = getRichText(message) || getPlainText(message);
    const shouldAddOnClickEvent = mobile && this.isClickableLink(contentText);
    if (!contentText) {
      return null;
    }
    const parsedRichText = getRichText(message) && autolinker.link(contentText, {
      stripPrefix: false
    });
    return /*#__PURE__*/_jsx(ContentText
    //senderName={senderName}
    , {
      messageId: message.id,
      contentText: parsedRichText || contentText,
      shouldAnnounce: isLastMessage,
      "aria-label": `${this.isSentFromVisitor() ? I18n.text('conversations-visitor-message-history.iSay') : I18n.text('conversations-visitor-message-history.subjectSays', {
        subject: senderName || I18n.text('conversations-visitor-message-history.agent')
      })} ${getPlainText(message)}`,
      onClickAction: shouldAddOnClickEvent ? this.handleOnClickEvent.bind(this) : () => {}
    });
  }
  renderMessageSection() {
    const {
      fileAttachments,
      message
    } = this.props;
    const shouldRenderInlineAttachments = !isEmailCMF(message) && fileAttachments && hasImageAttachments(fileAttachments);
    const hasContent = hasTextContent(message);
    if (!shouldRenderInlineAttachments && !hasContent) {
      return null;
    }
    return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      children: [this.renderContentText(), shouldRenderInlineAttachments && /*#__PURE__*/_jsx(InlineImageAttachments, {
        fileAttachments: fileAttachments
      }), this.props.quickReplySelect && typeof this.props.quickReplySelect === 'function' && this.props.quickReplySelect()]
    });
  }
  renderAttachmentsSection() {
    const {
      fileAttachments,
      message
    } = this.props;
    const attachments = isEmailCMF(message) ? fileAttachments : getNonImageAttachments(fileAttachments);
    return attachments && attachments.size ? /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: /*#__PURE__*/_jsx(AttachmentsFooter, {
        fileAttachments: attachments
      })
    }) : null;
  }
  render() {
    const {
      textColor
    } = this.context;
    const messageSection = this.renderMessageSection();
    const attachmentsSection = this.renderAttachmentsSection();
    const sendFromVisitor = this.isSentFromVisitor();
    const {
      hasUnansweredQuickReplyMessage,
      isLastMessage
    } = this.props;
    return /*#__PURE__*/_jsx(HyperlinkStyleWrapper, {
      hyperlinkColor: sendFromVisitor ? textColor : 'inherit',
      children: /*#__PURE__*/_jsxs(PrimaryMessageContent, {
        shouldFocusMessage: isLastMessage && hasUnansweredQuickReplyMessage,
        children: [messageSection, attachmentsSection, !messageSection && !attachmentsSection && /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
          children: /*#__PURE__*/_jsx(NoContentLabel, {})
        })]
      })
    });
  }
}
CommonMessageContent.displayName = 'CommonMessageContent';
CommonMessageContent.propTypes = {
  // @ts-expect-error - update after immutable conversion
  fileAttachments: PropTypes.instanceOf(List),
  hasUnansweredQuickReplyMessage: PropTypes.bool,
  isLastMessage: PropTypes.bool,
  message: RecordPropType('CommonMessage').isRequired,
  mobile: PropTypes.bool,
  quickReplySelect: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  senderName: PropTypes.string,
  toggleOpen: PropTypes.func
};
CommonMessageContent.contextType = ThemeContext;
export default CommonMessageContent;